<script>
    import { BookAccordionProvider } from '@repo/book-accordion';
    import { callable } from '$lib/firebase/firebase';
    import { contentDb } from '$lib/firebase/firebase';
    import {
        canAccessResource,
        canAccessTeacherOnlyMaterial,
        hasBookAccess,
        hasContentAction,
        hasRole,
    } from '$lib/access';
    import {
        getEntity,
        getEntityBreadcrumb,
        getEntitiesWhere,
        getFirestore,
    } from '$lib/DB';
    import { currentUser } from '$lib/stores';

    let { children } = $props();
</script>

<BookAccordionProvider
    access={{ hasRole, hasContentAction, canAccessResource, canAccessTeacherOnlyMaterial, hasBookAccess, currentUser }}
    db={{ getEntity, getEntityBreadcrumb, getEntitiesWhere, getFirestore, contentDb }}
    functions={{ callable }}
>
    {@render children?.()}
</BookAccordionProvider>
